var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "dashboard" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col third" }, [
        _c("div", { staticClass: "date" }, [_vm._v(_vm._s(_vm.date))])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col third" },
        [_c("Weather", { attrs: { data: _vm.weather } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col third" },
        [
          _c("Route", {
            attrs: { data: _vm.alewife, name: "Red Line Inbound - Alewife" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col third" },
        [
          _c("Route", {
            attrs: { data: _vm.magoun, name: "Bus 77 South - Magoun" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col third" },
        [
          _c("Route", {
            attrs: { data: _vm.gladstone, name: "Bus 77 North - Gladstone" }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col whole center" }, [
        _c(
          "button",
          {
            staticClass: "refresh",
            on: {
              click: function($event) {
                _vm.refresh()
              }
            }
          },
          [_vm._v("Refresh")]
        ),
        _vm._v(" "),
        _c("div", [
          _c("em", [_vm._v("Last updated: " + _vm._s(_vm.lastUpdated))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col third center" }, [
      _c("h1", { staticClass: "header" }, [_vm._v("53 Magoun Street")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fbdd7d22", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbdd7d22","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/dashboard.vue
// module id = 354
// module chunks = 0